/**
 * 三方对接供应商数据报表 — 页面入口
 * 实现见组件：@/components/cabinet/report/CThirdSupplierProductReport.vue
 * PRD：docs/PRD-供应商报表.md
 */
export default {
  body: {
    cmpt: {
      type: 'CThirdSupplierProductReport'
    }
  }
}
